import apiClient from "./apiService";

export const fetchReport = async (page = 1) => {
  try {
    const response = await apiClient.get("/admin/report", {
      params: { page },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
